export const PREVIOUS_SESSIONS_LIST_DEFAULT_LIMIT = 2
